import { AxiosRequestConfig } from 'axios';
import client from '../client';

export function get_report(
    from: string = '',
    to: string = '',
    serviceProviderId: string | null = null,
    customConfig?: AxiosRequestConfig
) {
    const url = '/report';
    const params: { from: string; to: string; service_provider_id?: string } = {
        from: from,
        to: to,
    };
    if (serviceProviderId) {
        params.service_provider_id = serviceProviderId;
    }
    const config = {
        ...customConfig,
        params,
        responseType: 'blob',
    };
    return client.get(url, config as AxiosRequestConfig);
}
